import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";


let userToken = localStorage.getItem("userToken");

export default function EditArticle({ itemToEdit, setItemToEdit, endpoint, refresh, setRefresh }) {
  const [input, setInput] = useState();
  const [image, setImage] = useState(null);
  const [userInfo, setuserInfo] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const fileInputRef = useRef();

  const ref = useRef();

  useEffect(() => {
    async function fetchData() {
      if (Object.keys(itemToEdit).length > 0) {
        try {
          const response = await fetch(`${API}/${endpoint}/${itemToEdit.id}?populate=*`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
            method: "GET",
          });
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const res = await response.json();
          setInput(res.data.attributes);
          setSelectedUser(res.data?.attributes?.users_permissions_user?.data?.id);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    async function getUsers() {
      fetch(`${API}/users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        method: "GET",
      }).then(async (res) => {
        const response = await res.json();
        setUsers(response);
      });
    }

    async function getUser() {
      fetch(`${API}/users/me?populate=*`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setuserInfo(respone);
      });
    }

    fetchData();
    getUsers();
    getUser();
  }, [itemToEdit]);

  const handleInputChange = (field, value) => {
    setInput({
      ...input,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const saveChanges = () => {
    const updatedData = { ...input, users_permissions_user: selectedUser };

    if (image && image instanceof File) {
      const formData = new FormData();

      formData.append("data", JSON.stringify(updatedData));

      formData.append("files.image", image);

      fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      })
        .then(async (res) => {
          if (res.ok) {
            setRefresh(!refresh);
            setItemToEdit({});
            setInput(null);
            setImage(null);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          } else {
            const errorData = await res.json();
            console.error("Error updating entry:", errorData);
            toast("Error updating entry", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          toast("Error updating entry", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        });
    } else {
      fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: {
            title: input.title,
            link: input.link,
            users_permissions_user: selectedUser,
          },
        }),
      })
        .then(async (res) => {
          if (res.ok) {
            setRefresh(!refresh);
            setItemToEdit({});
            setInput(null);
            setImage(null);

            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          } else {
            const errorData = await res.json();
            console.error("Error updating entry:", errorData);
            toast("Error updating entry", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          toast("Error updating entry", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        });
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#00000030",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex">
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "fixed",
          zIndex: 9999,
        }}
        onClick={() => {
          setItemToEdit({});
          setInput(null);
        }}></div>
      <div
        ref={ref}
        style={{
          width: "70%",
          minWidth: 880,
          height: 400,
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: 15,
          overflowY: "scroll",
          zIndex: 99999,
        }}>
        {input && (
          <div
            className="fadeInFast"
            style={{
              marginTop: 10,
              marginBottom: 20,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
            }}>
            <div style={{ width: "100%", display: "flex", marginBottom: 10 }}>
              <div style={{ width: "50%", height: "100%" }}>
                <TextField
                  label="Title"
                  sx={{ width: "90%", mb: 2 }}
                  value={input.title}
                  onChange={(e) => handleInputChange("title", e.target.value)}
                />
                <TextField
                  label="Link"
                  sx={{ width: "90%" }}
                  value={input.link}
                  onChange={(e) => handleInputChange("link", e.target.value)}
                />
                {(userInfo?.id === 40 || userInfo?.id === 36) && (
                  <FormControl sx={{ width: "90%", mt: 2 }}>
                    <InputLabel id="author-select-label">Select Author</InputLabel>
                    <Select
                      labelId="author-select-label"
                      id="author-select"
                      value={selectedUser}
                      label="Select Author"
                      onChange={(e) => {
                        setSelectedUser(e.target.value);
                      }}>
                      {users.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                          {user.username}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}>
                <div
                  style={{
                    border: "dashed",
                    borderWidth: 1,
                    borderColor: "grey",
                    height: 135,
                    marginTop: 1,
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => fileInputRef.current.click()}>
                  {image ? (
                    <img
                      src={URL.createObjectURL(image)}
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        input.image
                          ? SERVER_DOMAIN + input.image?.data?.attributes?.url
                          : require("../../assets/icons/add-image.png")
                      }
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <p style={{ color: "#888", fontSize: 13, marginTop: 5 }}>
                    Click here to add an image
                  </p>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleImageChange}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="submitBTN" style={{ margin: "0 auto", marginTop: 0 }} onClick={saveChanges}>
          Save Changes
        </div>
      </div>
    </div>
  );
}
